import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import SvgIcon from '@material-ui/core/SvgIcon';
import './button.scss';

class BaseIconButton extends Component {
    render() {
        const {className, tooltipClasses, tooltipTitle, tooltipIsVisible, onTooltipClick, tooltipShow = () => {}, tooltipPlacement, icon, viewBox, ...rest} = this.props;

        return (
            <div className={`base-icon-button ${className || ''}`}>
                <Tooltip enterDelay={500}
                    disableTouchListener={true}
                    open={tooltipIsVisible}
                    classes={tooltipClasses || {popper: 'base-tooltip', tooltip: 'tooltip-label'}}
                    title={tooltipTitle || ''}
                    placement={tooltipPlacement}>
                    <div className="base-tooltip-inner" onTouchStart={onTooltipClick} onMouseEnter={tooltipShow(true)} onMouseLeave={tooltipShow(false)}>
                        <IconButton
                            classes={{root: 'button'}} {...rest}>
                            <SvgIcon classes={{root: 'icon'}} viewBox={viewBox}>{icon}</SvgIcon>
                        </IconButton>
                    </div>
                </Tooltip>
            </div>
        );
    }
}

BaseIconButton.propTypes = {
    icon: PropTypes.object.isRequired,
    className: PropTypes.string,
    viewBox: PropTypes.string,
    tooltipPlacement: PropTypes.string,
    tooltipTitle: PropTypes.string,
    tooltipIsVisible: PropTypes.bool,
    tooltipShow: PropTypes.func
};

export default BaseIconButton;
